import axios from 'axios';
import { IThisUserState } from '../store/thisUser/thisUserSlice';
import { IHISInformationState } from '../containers/HIS/HISSMSConfiguration';
import { getDomainAndPort } from './Utils';

const domainAndPort = getDomainAndPort();

const { protocolDomain, port } = domainAndPort;
export const baseURL = `${protocolDomain}${
  port !== '80' ? ':' + port : ''
}/sathissms`;
const hisSmsApi = axios.create({
  baseURL,
});

export const handleFetchInitialInformation = async (
  thisUser: IThisUserState,
  includeDeleted: boolean = true
) => {
  const res = await hisSmsApi.get('/hisInformation/getAll', {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${thisUser.access_token}`,
    },
    params: {
      includeDeleted,
    },
  });

  return res.data;
};

export const handleCreateUpdateHIS = async (
  data: Partial<IHISInformationState>,
  thisUser: IThisUserState
) => {
  return await hisSmsApi.post(
    '/hisInformation/createOrUpdate',
    { ...data },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${thisUser.access_token}`,
      },
    }
  );
};

export const handleConnectionTest = async (
  id: string,
  thisUser: IThisUserState
) => {
  const res = await hisSmsApi.post(
    '/hisConnection/test',
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${thisUser.access_token}`,
      },
      params: { id },
    }
  );

  return res.data.status;
};

export const handleFetchPatient = async (
  startDate: number,
  dueDate: number,
  id: string,
  thisUser: IThisUserState
) => {
  const res = await hisSmsApi.get('/patientInformation/getSMSCount', {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${thisUser.access_token}`,
    },
    params: { fromDate: startDate, toDate: dueDate },
  });
  return res.data[id];
};

export const handleSamplePhonenumberTest = async (
  HISId: string,
  phoneNumber: string,
  thisUser: IThisUserState
) => {
  await hisSmsApi.post(
    '/hisConnection/manualSend',
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${thisUser.access_token}`,
      },
      params: {
        id: HISId,
        phoneOverwrite: phoneNumber,
        dryRun: false,
        pageSize: 1,
      },
    }
  );
};
